import { render, staticRenderFns } from "./choiceType.vue?vue&type=template&id=62ee9b61&scoped=true"
import script from "./choiceType.vue?vue&type=script&lang=js"
export * from "./choiceType.vue?vue&type=script&lang=js"
import style0 from "./choiceType.vue?vue&type=style&index=0&id=62ee9b61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ee9b61",
  null
  
)

export default component.exports